import React, { useState } from "react";
import { Button, TextField, Container, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import API from "../CodeView/MyApi";

function Scm() {
  const [textFields, setTextFields] = useState([""]); // Initialize with a single empty string
  const navigate = useNavigate();

  const addTextField = () => {
    setTextFields([...textFields, ""]); // Add an empty string for a new text field
  };

  const handleTextFieldChange = (index, value) => {
    const newFields = [...textFields];
    newFields[index] = value;
    setTextFields(newFields);
  };

  const removeTextField = (index) => {
    const newFields = [...textFields];
    newFields.splice(index, 1);
    setTextFields(newFields);
  };

  const handleSubmit = async () => {
    const InstructionValues = textFields.map((value, index) => ({
      // id: index + 1,
      instrction: value,
    }));

    const payload = {
      Instruction: InstructionValues,
    };
    const test_code = await API.postData("/scm/gen_code", InstructionValues);
    if (test_code) {
      console.log(test_code);
      navigate("/codeview", { state: test_code.code });
    }
    // console.log("Instruction values:", InstructionValues);
  };

  return (
    <Container className="form">
      <Stack spacing={2}>
        {textFields.map((value, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <TextField
              value={value}
              onChange={(e) => handleTextFieldChange(index, e.target.value)}
              label={`Instruction ${index + 1}`}
              variant="outlined"
              style={{ width: "90%" }}
            />
            <Button
              style={{ height: "fit-content" }}
              onClick={() => removeTextField(index)}
              variant="contained"
              color="info"
            >
              Remove
            </Button>
          </div>
        ))}
        <Stack spacing={2} direction="row">
          <Button onClick={addTextField} variant="contained" color="primary">
            Add Instruction
          </Button>
          <Button onClick={handleSubmit} variant="contained" color="primary">
            Submit
          </Button>
        </Stack>
      </Stack>
    </Container>
  );
}

export default Scm;
